// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { MerchantAdministrationOperationsService } from '../generated/api/merchantAdministrationOperations.service';

@Injectable({ providedIn: 'root' })
export class MerchantAdministrationOperationsClientService {
  constructor(private readonly client: MerchantAdministrationOperationsService) {}
  // <generated-client-wrappers:methods>
  createSettlementHold(
    request: WrapperApi.MerchantSettlementHoldCreateRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.MerchantSettlementHoldResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsCreateSettlementHold(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  financials(
    merchantId?: string,
    currencyCode?: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.MerchantFinancialOversightResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsFinancials(
      merchantId,
      currencyCode,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  getOffering(
    merchantId: string,
    offeringId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.OfferingResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsGetOffering(
      merchantId,
      offeringId,
      'body',
      reportProgress,
      options,
    );
  }

  getOfferings(
    merchantId: string,
    searchTerm?: string,
    statusKey?: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.OfferingPageResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsGetOfferings(
      merchantId,
      searchTerm,
      statusKey,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  releaseSettlementHold(
    holdId: string,
    request: WrapperApi.MerchantSettlementHoldReleaseRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.MerchantSettlementHoldResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsReleaseSettlementHold(
      holdId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  search(
    searchTerm?: string,
    statusKey?: string,
    isVerified?: boolean,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.MerchantPageResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsSearch(
      searchTerm,
      statusKey,
      isVerified,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  summary(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.MerchantAdministrationSummaryResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsSummary(
      'body',
      reportProgress,
      options,
    );
  }

  updateLifecycle(
    merchantId: string,
    request: WrapperApi.MerchantLifecycleUpdateRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.MerchantResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsUpdateLifecycle(
      merchantId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  updateOfferingFulfillmentBehavior(
    merchantId: string,
    offeringId: string,
    request: WrapperApi.OfferingFulfillmentBehaviorUpdateRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.OfferingResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsUpdateOfferingFulfillmentBehavior(
      merchantId,
      offeringId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  verify(
    merchantId: string,
    request: WrapperApi.MerchantVerificationRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.MerchantResponse> {
    if (!this.client)
      throw new Error(
        'MerchantAdministrationOperationsService is not available',
      );
    return this.client.merchantAdministrationOperationsVerify(
      merchantId,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
